import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CoreTargetService } from 'src/app/core/services/target.service';
import {
  FORCE_REGION,
  USE_GOLIVE_BASE,
} from 'src/app/core/http/http-context.tokens';
import { HttpContext } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private http: HttpClient,
    private targetService: CoreTargetService,
  ) {}

  getUsers(target: any): Observable<any> {
    var params = '?target=' + target;
    return this.http.get('/getUsers' + params);
  }

  getRoles(): Observable<any> {
    return this.http.get('/getUserRoles');
  }

  resendEmail(email: any): Observable<any> {
    return this.http.post('/resendEmail', {
      email: email,
    });
  }

  getRoleList(): Observable<any> {
    return this.http.get('/privileges/rolePrivileges');
  }

  getCurrentUserRoles(email: any): Observable<any> {
    return this.http.get('/privileges/userPrivileges/user?email=' + email);
  }

  addNewRolePrivileges(data: any): Observable<any> {
    return this.http.post('/privileges/rolePrivileges', data);
  }

  editUserRolePrivileges(data: any): Observable<any> {
    return this.http.put('/privileges/userPrivileges/user', {
      email: data.email,
      privileges: data.privileges,
      shopID: data.shopID,
    });
  }

  updateAllUsersPrivileges(data: any): Observable<any> {
    return this.http.put('/privileges/userPrivileges/multiple', data);
  }

  deleteRolePrivilege(data: any): Observable<any> {
    return this.http.delete('/privileges/rolePrivileges/' + data);
  }

  updateBugTrackingStatus(data: any): Observable<any> {
    return this.http.put('/privileges/bugSubscription/user', data);
  }

  updateBugTrackingStatusAll(data: any): Observable<any> {
    return this.http.put('/privileges/bugSubscription/users', data);
  }

  updateSeoSubscriptionStatus(data: any): Observable<any> {
    return this.http.put('/privileges/seosubscription/user', data);
  }

  updateSeoSubscriptionStatusAll(data: any): Observable<any> {
    return this.http.put('/privileges/bugSubscription/users', data);
  }

  createUser(data: any): Observable<any> {
    if (data.mode == 'instant') {
      return this.http.post('/createUser?instant=true', {
        username: data.name,
        name: data.name,
        id: data.target,
        email: data.email,
        password: data.password,
        shopID: data.target,
        role: data.role,
        authProvider: data.authProvider,
      });
    } else {
      return this.http.post('/createUser', {
        username: data.name,
        name: data.name,
        id: data.target,
        email: data.email,
        shopID: data.target,
        role: data.role,
        authProvider: data.authProvider,
      });
    }
  }

  editUser(data: any): Observable<any> {
    return this.http.post('/updateUser', {
      email: data.email,
      name: data.name,
      oldEmail: data.oldEmail,
      role: data.role,
      shopID: data.shopID,
      authProvider: data.authProvider,
    });
  }

  deleteUser(email: any): Observable<any> {
    return this.http.post('/deleteUser', {
      email: email,
      shopID: this.targetService.getSelectedTarget('target'),
    });
  }

  getProductRetrivalConfig(): Observable<any> {
    return this.http.get('/productRetrievalConfig');
  }

  returnDataRetrivalConfig(): Observable<any> {
    return this.http.get('/returnDataRetrievalConfig');
  }

  editProductRetrivalConfig(data: any): Observable<any> {
    return this.http.put('/productRetrievalConfig', data);
  }

  editReturnRetrivalConfig(data: any): Observable<any> {
    return this.http.put('/returnDataRetrievalConfig', data);
  }

  createNewClient(data: any): Observable<any> {
    return this.http.post('/createNewClient', data, {
      context: new HttpContext().set(FORCE_REGION, data.region),
    });
  }

  getSettings(target: any) {
    var params = '?target=' + target;
    return this.http.get<any>('/settings' + params);
  }

  updateSettings(data: any, oldData: any, target: any) {
    var obj = {
      newObject: {
        ...data,
      },
      oldObject: {
        ...oldData,
      },
    };
    return this.http.post('/updateSettings?target=' + target, obj);
  }

  getGoLiveObject(data: any): Observable<any> {
    return this.http.post('/get_target_connections', data, {
      context: new HttpContext().set(USE_GOLIVE_BASE, true),
    });
  }
  setGoLiveProcess(data: any): Observable<any> {
    return this.http.post('/golive_process', data, {
      context: new HttpContext().set(USE_GOLIVE_BASE, true),
    });
  }
  toggleNudgeLite(status: boolean, target: string): Observable<any> {
    return this.http.post('/toggleNudgeLite', { status, target });
  }

  updateBacklinkMarketplaceConfig(data: any): Observable<any> {
    return this.http.post('/backlink-marketplace/client/organicConfig', data);
  }

  getBacklinkMarketplaceConfig(target: string): Observable<any> {
    return this.http.get(
      '/backlink-marketplace/client/organicConfig?target=' + target,
    );
  }

  getDashboardEditorState(type: string): Observable<any> {
    return this.http.get(`/dashboard-editor-state?type=${type}`, {
      context: new HttpContext().set(FORCE_REGION, 'west-eu'),
    });
  }

  setDashboardEditorState(type: string, status: boolean): Observable<any> {
    return this.http.post(
      `/dashboard-editor-state`,
      {
        type: type,
        editorUnderMaintenance: status,
      },
      {
        context: new HttpContext().set(FORCE_REGION, 'west-eu'),
      },
    );
  }
}
